import { axios } from '../../services/axios';

export default async function getSRTService(serviceId) {
    return axios.get(`/Service/${serviceId}`);
}
